module.exports = __webpack_public_path__ + "static/media/interface-right-side.fd7b6248.png";